<template>
  <div v-if="isViewActiveLocal" ref="topic_content">
    <div class="vx-row limit-width_fixed-scalable" >
      <div class="vx-col mb-3" vs-lg="4" style="margin-top:8px">
        <span style="font-size: 18pt;font-weight: 100;color:white;">
          You have selected:
        </span>
      </div>
      <div class="vx-col" vs-lg="4" style="margin:auto">
        <vx-card class="mt-3 glow-effect_dark limit-width_fixed card__no-padding bg-color">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text input-group_prepend-slot-bg">
                <span><feather-icon class="pt-1" icon="CodesandboxIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button size="large"
                        class="w-full button-text__left-align glow-effect_primary__hover back-button bg-color"
                        style="border-radius:0 7px 7px 0"
                        type="filled"
                        color=""
                        @click="backToSelectModule">
              <span id="backArrow"><feather-icon class="pt-1 back-icon__hover-only" icon="ArrowLeftIcon" svg-classes="stroke-current"></feather-icon></span>
              {{ selectedModule.moduleName }}
            </vs-button>
          </vx-input-group>
        </vx-card>
      </div>
    </div>
    <div class="mt-8">
      <ul style="margin-top: 1rem;flex-wrap: wrap;">
        <div class="limit-width_fixed-scalable" style="text-align: left;">
          <li class="my-4">
            <vx-card class="glow-effect_dark limit-width_fixed-scalable card__no-padding bg-color">
              <vx-input-group>
                <template slot="prepend">
                  <div class="prepend-text input-group_prepend-slot-bg">
                    <span><feather-icon class="pt-1" icon="ArrowRightIcon" svg-classes="stroke-current"></feather-icon></span>
                  </div>
                </template>

                <vs-button
                  ref="continueWatchingBtn"
                  size="large"
                  class="w-full glow-effect_primary button-text__left-align school-primary_gradient"
                  style="border-radius:0 7px 7px 0"
                  @click="continueFrom(selectedModule.moduleId, selectedModule.taskDisplayId)">
                  Continue Where You Left Off
                </vs-button>
              </vx-input-group>
            </vx-card>
          </li>
        </div>
        <div v-if="continueMilestones.filter(function(item) {return item.moduleId == selectedModule.moduleId}).length > 0" class="limit-width_fixed-scalable" style="text-align: left;">
          <li>
            <vx-card class="glow-effect_bg-color__blend card__no-padding bg-color" style="width: 410px">
              <vx-input-group>

                <vs-button
                  :disabled="true"
                  size="large"
                  class="button__fully-opaque button-text__left-align glow-effect_bg-color__blend header_button-item text__school-tertiary-color bg-color"
                  type="filled"
                  color="">
                  Or, continue from a Milestone
                </vs-button>
              </vx-input-group>
            </vx-card>
          </li>
        </div>
        <li v-for="(_milestone, index) in continueMilestones.filter(function(item) {return item.moduleId == selectedModule.moduleId})" :key="index" class="mb-5">
          <vx-card class="glow-effect_dark limit-height_content-height limit-width_fixed-scalable card__no-padding bg-color">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text limit-height_content-height input-group_prepend-slot-bg" style="width: 70px;border-radius: 5px 0 0 5px !important;">
                  <span><feather-icon class="pt-1 ml-3" icon="AnchorIcon" svg-classes="stroke-current"></feather-icon></span>
                </div>
              </template>

              <vs-button
                size="large"
                class="w-full glow-effect_primary limit-height_content-height button-text__left-align school-primary_gradient"
                style="border-radius:0 7px 7px 0;"
                @click="continueFrom(_milestone.moduleId, _milestone.taskDisplayId)">
                {{ `${_milestone.taskName} [${_milestone.taskDisplayId}]` }}<br><strong>Date Last Accessed:&nbsp;</strong>{{ _milestone.dateLastAccessed }}
              </vs-button>
            </vx-input-group>
          </vx-card>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    
  },
  data() {
    return {
      
    };
  },
  props: {
    isViewActive: {
      required: false,
    },
    selectedModule: {
      type: Object,
      required: true
    },
    continueMilestones: {
      type: Array,
      required: false
    }
  },
  watch: {
    isViewActive: function (val) {
      if(val){
        
      }
    }
  },
  computed: {
    isViewActiveLocal: {
      get() {
        return this.isViewActive;
      }
    }
  },
  methods: {
    continueFrom(moduleId, taskDisplayId) {
      this.$emit('continueFrom', moduleId, taskDisplayId);
    },
    backToSelectModule() {
      this.$emit("backToSelectModule");
    }
  }
};
</script>